import { createFileRoute } from "@tanstack/react-router";

import { My } from "@/features/my";

export const Route = createFileRoute("/(member)/(protected)/my")({
  component: My,
});
